export default __webpack_public_path__ + "static/media/dash3.c1709873.svg";